export const transmitterFillPercent = (value, unit, maxMeters) => {
  if (value == null || value === "" || maxMeters == null || maxMeters === "") return null;
  const reading = Number(value);
  const range = Number(maxMeters);
  if (!Number.isFinite(reading) || !Number.isFinite(range) || range <= 0) return null;
  const normalizedUnit = String(unit || "m").trim().toLowerCase();
  const fullScale = normalizedUnit === "cm" ? range * 100 :
    ["ft", "foot", "feet"].includes(normalizedUnit) ? range * 3.280839895013123 : range;
  return Math.round(Math.max(0, Math.min(100, reading / fullScale * 100)));
};

export const formatLevelRangeMax = (value) =>
  value == null || value === "" ? "" : String(Number(value));

export const isLevelRangeInput = (value) => /^\d*\.?\d*$/.test(value);
